<template>
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>
      </div>
      <el-button size="small" type="success" @click="export2Excel()">导出excel</el-button>
    </div>

    <el-table ref="allUserList" v-loading="loading" :data="tableData"
              :header-cell-style="{ background: '#F5F7FA' }" style="width: 100%; margin-bottom: 20px" border>
      <el-table-column prop="userCreditCardId" label="#" align="center" width="150"></el-table-column>
      <el-table-column prop="creditCardNum" label="学分卡号" align="center" width="150"></el-table-column>
      <el-table-column prop="name" label="学分卡姓名" align="center"></el-table-column>
      <el-table-column prop="userId" label="用户ID" align="center" width="150"></el-table-column>
      <el-table-column prop="userInfo" label="用户" align="center" width="200">
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="mobilePhone" label="电话号码" align="center" width="150"></el-table-column>
      <el-table-column prop="hospital" label="医院" align="center"></el-table-column>
      <el-table-column prop="subject" label="科室" align="center"></el-table-column>
      <el-table-column prop="idCardNum" label="身份证号" align="center" width="200"></el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.currentPage" @current-change="currentPageChange"/>
  </div>
</template>

<script>
import {getUserCreditCardList} from "@/api/mai/liveManagement/liveManagement";
import {handleResWithReturn} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";
import UserInfo from "@/components/UserInfo/UserInfo";
import {export_json_to_excel} from "@/vendor/Export2Excel";
import {getDisplayName} from "@/utils/userutil";

export default {
  name: "liveCreditCardInfo",
  components: {UserInfo},
  created() {
    this.liveID = this.$route.query.liveID;
    this.refreshData()
  },
  data() {
    return {
      liveID: 0,
      searchValue: "",
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      tableData: [],
      loading: false
    }
  },
  methods: {
    search() {
      this.pageOpt.currentPage = 1
      this.refreshData()
    },
    currentPageChange(page) {
      this.pageOpt.currentPage = page
      this.refreshData()
    },
    async refreshData() {
      let res = await this.getUserCreditCardList();
      if (isVaild(res)) {
        this.tableData = res.rows
        this.pageOpt.totalCount = res.total
      }
    },
    async getUserCreditCardList(pageSize = this.pageOpt.pageSize, pageNumber = this.pageOpt.currentPage) {
      let param = {
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageNumber: pageNumber,
        pageSize: pageSize,
      }
      this.loading = true;
      let response = await getUserCreditCardList(param)
      this.loading = false;
      if (handleResWithReturn(response)) {
        return response.data
      }
      return null
    },
    async export2Excel() {
      let allDataResponse = await this.getUserCreditCardList(0, 1)
      if (isVaild(allDataResponse)) {
        let exportData = allDataResponse.rows
        if (exportData.length === 0) {
          this.$message.info('没有要导出数据')
          return;
        }
        let {
          tName,
          tHeader,
          filterValue
        } = this.getExcelInfo()
        let list = this.formatChatInfoTable(exportData)
        let data = this.formatJson(filterValue, list)
        export_json_to_excel({
          header: tHeader,
          data,
          filename: tName,
          autoWidth: true,
          bookType: "xlsx",
        })
      }
    },
    getExcelInfo() {
      let tName = '学分卡数据';
      let tHeader;
      let filterValue;
      tHeader = ['#','学分卡号','学分卡姓名', '用户ID', '用户', '电话号码', '医院', '科室', '身份证号']
      filterValue = [
        'userCreditCardId',
        'creditCardNum',
        'name',
        'userId',
        'userInfo',
        'mobilePhone',
        'hospital',
        'subject',
        'idCardNum',
      ]
      return {
        tName,
        tHeader,
        filterValue
      }
    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
    /**
     * 格式化 userInfoTable
     *
     * @param list
     */
    formatChatInfoTable(list) {
      let newList = list.map(item => {
        item.userInfo = getDisplayName(item)
        return item
      })

      return newList
    },
  }
}
</script>

<style scoped>

</style>